import { useNavigation } from '@react-navigation/native';
import { View, SxProp, useDripsyTheme } from 'dripsy';
import { RootStackParamList, RootTabParamList } from 'types';
import { SVGIconList } from '@/design-system/components/icons/Icon';
import { SegmentSelect, SegmentSelectItem } from '@/design-system/components/buttons/segmentSelect/SegmentSelect';
import { DevToolsStackParamList, DevToolsStackRoutes } from '../types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useCallback } from 'react';
export interface NavigationData {
  title: string;
  toPage: keyof RootStackParamList | keyof RootTabParamList | keyof DevToolsStackParamList;
  icon?: SVGIconList;
}

interface DevToolsPageNavigationProps<T> {
  data: Array<SegmentSelectItem<T>>;
  currentPage?: T;
  sx?: SxProp;
  onChange?: (item: T) => void;
}

export const DevToolsPageNavigation = <T extends unknown>({ data, currentPage, sx, onChange }: DevToolsPageNavigationProps<T>) => {
  const navigation = useNavigation<NativeStackNavigationProp<DevToolsStackParamList>>();
  const { theme } = useDripsyTheme();

  const onChangePage = useCallback(
    (item: T) => {
      navigation.navigate(item as DevToolsStackRoutes);
    },
    [navigation]
  );

  return (
    <View sx={{ ...styles.container, ...sx }}>
      {currentPage !== undefined ? (
        <SegmentSelect
          key="overview-page-item-header-suffix-0"
          data={data}
          value={currentPage}
          onValueChange={(item) => {
            onChangePage(item);
          }}
          wrapperBackgroundColor="#FFFFFF"
          buttonWidth={124}
          buttonHeight={44}
          buttonBackgroundColors={theme?.linearGradients?.SegmentSelectActive}
          labelColorActive="#FFFFFF"
          labelColorInactive="#4D4D4D"
          animationDuration={0}
        />
      ) : null}
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    mt: '$5',
    flexDirection: 'row',
    gap: '$7'
  }
};
